module.exports = __webpack_public_path__ + "static/learning-7bb6694e3e33965d0e2ba8e96b508209.png";